import { frameConfigBasic } from '../../../AppConfig';
import { getScreenTranslation } from '../../../utils/translations';
import { RequestLoadingTemplate } from 'InternalLibrary';
import { useTranslation } from 'react-i18next';
import useResolutionResolverOnlineBank from './useResolutionResolverOnlineBank';

export default function OnlineBankWaiting() {
  useResolutionResolverOnlineBank();
  const i18Next = useTranslation();

  return (
    <RequestLoadingTemplate
      {...frameConfigBasic}
      hideLogout
      hideMobileFooter
      content={getScreenTranslation(
        'online_bank_identification_waiting',
        i18Next,
      )}
      sectionID={0}
      logoSquare
      logo
    />
  );
}
